import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { useSelector } from "react-redux";

export const FixedbottomButtonCover = ({ children, ...rest }) => {
  const { isCollapseSidebar: isCollapseMenu } = useSelector(
    (state) => state.profileDetailsReducer,
  );
  const isCollapseSidebar =
    isCollapseMenu !== null
      ? isCollapseMenu
      : JSON.parse(localStorage.getItem("isCollapsedSideMenu") || null);

  return (
    <div
      className={`${globalStyles.fixedbottomButtonCover} ${isCollapseSidebar ? globalStyles.isCollapseSideMenu : ""}`}
      {...rest}
    >
      {children}
    </div>
  );
};
